<!-- <div class="navbar-top" [ngClass]="giantConfig.layout.navbar.secondaryBackground">
    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
         </button>
 
    </div>
    <div class="logo">
        <img class="logo-icon" src="assets/images/logo/giant2_new.png">
     </div>



</div> -->


<div class="navbar-scroll-container" [ngClass]="giantConfig.layout.navbar.primaryBackground" giantPerfectScrollbar
    [giantPerfectScrollbarOptions]="{suppressScrollX: true}">

    <!-- <div class="user" fxLayout="column" [ngClass]="giantConfig.layout.navbar.secondaryBackground">

        <div class="h3 username">Charlie Adams</div>
        <div class="h5 email hint-text mt-8">adams.charlie@mail.com</div>
        <div class="avatar-container" [ngClass]="giantConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
        </div>

    </div> -->

    <div class="navbar-content">
        <navigation class="material2" layout="vertical"></navigation>
    </div>

</div>